import { Dropdown } from "primereact/dropdown";

const DropDownTemplate = (options, values) => {
    
        return (
            <Dropdown
                value={options?.value}
                onChange={(e) => options.filterApplyCallback(e.value)}
                options={values}
                placeholder="Виберіть значення"
                className="p-column-filter"
            />
        );
    };

export default DropDownTemplate;